import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';

const NavOverflowMenu = ({ links = [] }) => {
  if (!links.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-1">
          <MoreHorizontal className="h-4 w-4" /> More
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {links.map(link => (
          <DropdownMenuItem key={link.path} asChild>
            <Link to={link.path} className="flex items-center gap-2">
              {link.icon && <link.icon className="h-4 w-4" />}
              {link.name}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavOverflowMenu;

